import React, { Component } from 'react';
import { array, string, bool, func } from 'prop-types';
import styles from './styles.scss';

import { Dropdown, Input, Text } from 'wix-style-react';

class ConnectionDropdown extends Component {
  static propTypes = {
    items: array,
    selectedId: string,
    disabled: bool,
    dataHook: string,
    placeholder: string,
    disabledPlaceholder: string,
    onSelect: func,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedId: props.selectedId,
    };
  }

  handleOnSelect(selectedId) {
    const { onSelect } = this.props;

    this.setState({ selectedId });
    onSelect(selectedId);
  }

  render() {
    const {
      disabled,
      placeholder,
      disabledPlaceholder,
      dataHook,
      items,
    } = this.props;
    const { selectedId } = this.state;

    if (disabled) {
      return <Input disabled size="small" placeholder={disabledPlaceholder} />;
    }
    return (
      <Dropdown
        size="small"
        popoverProps={{ appendTo: 'scrollParent' }}
        dropdownWidth="258px"
        disabled={disabled}
        dataHook={dataHook}
        options={items.map((item) => ({
          id: item.id,
          value: item.description ? (
            <div className={styles[`item-container`]}>
              <div>
                <Text weight="normal" light={item.id === this.state.selectedId}>
                  {item.text}
                </Text>
              </div>
              <div className={styles.description}>
                <Text size="small" light={item.id === this.state.selectedId}>
                  {item.description}
                </Text>
              </div>
            </div>
          ) : (
            <Text weight="normal" light={item.id === this.state.selectedId}>
              {item.text}
            </Text>
          ),
          ...item,
        }))}
        onSelect={(option) => this.handleOnSelect(option.id)}
        selectedId={selectedId}
        placeholder={placeholder}
        valueParser={(option) => option.text}
      />
    );
  }
}

export default ConnectionDropdown;
